import {
  Thunder,
  MapType,
  ValueTypes,
  Query,
  Chain,
  Zeus,
} from './graphql-zeus'
import {
  OperationContext,
  useQuery,
  UseQueryResponse,
  UseQueryState,
} from 'urql'

export type MyOperationToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  variables?: Record<string, any>,
) => UseQueryState<MapType<T, Z>, object> & {
  refetch: (opts?: Partial<OperationContext>) => void
  loading: boolean
}

export const useZeus: MyOperationToGraphQL<ValueTypes['Query'], Query> = (
  query: any,
  variables?: any,
) => {
  const queryString = Zeus.query(query) as any
  const [result, refetch] = useQuery({
    query: queryString,
    variables,
  })
  return { ...result, refetch, loading: result.fetching } as any
}

export const chain = Chain('/api')
